import { render, staticRenderFns } from "./EditNecessity.vue?vue&type=template&id=688df4da&scoped=true"
import script from "./EditNecessity.vue?vue&type=script&lang=js"
export * from "./EditNecessity.vue?vue&type=script&lang=js"
import style0 from "./EditNecessity.vue?vue&type=style&index=0&id=688df4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688df4da",
  null
  
)

export default component.exports